// @flow
export const geocodingRadius = 30;
